import { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

import { ValidationProps } from './CommonTypes';
import { Direction } from './Direction';

export type InputContainerProps = {
  width?: string;
  marginTop?: string;
  marginBottom?: string;
  marginRight?: string;
};

export const InputContainer = styled.div<InputContainerProps>`
  width: ${(props) => props.width || '220px'};
  margin-top: ${({ theme, marginTop }) => marginTop || theme.spacing(0.5) || '5px'};
  margin-bottom: ${({ theme, marginBottom }) => marginBottom || theme.spacing(0.5) || '5px'};
  margin-right: ${({ marginRight }) => marginRight || 0};
`;

export const CheckboxContainer = styled.div<InputContainerProps>`
  width: ${(props) => props.width || 'fit-content'};
  margin-top: ${({ theme, marginTop }) => marginTop || theme.spacing(2) || '20px'};
  margin-bottom: ${({ theme, marginBottom }) => marginBottom || theme.spacing(0.5) || '5px'};
  margin-right: ${({ marginRight }) => marginRight || 0};
`;

export const SimpleWrapper = styled.div<{
  direction?: Direction;
  height?: string;
}>`
  display: flex;
  flex: 1 1 0;
  flex-direction: ${(props) => (props.direction === 'horizontal' ? 'row' : 'column')};
  justify-content: flex-start;
  height: ${(props) => props?.height || 'inherit'};
`;

export const outline = css`
  &:focus {
    outline: 2px solid rgb(79 157 209 / 56%) !important;
    outline-offset: -1px;
  }
`;

export const fieldOutline = css`
  &:focus {
    border: 2px solid ${({ theme }) => theme?.palette?.colors?.highlight || '#D5763F'} !important;
    border-radius: 2px !important;
    opacity: 1;
  }
`;

export const GenericGridCell = styled.div`
  padding-left: 15px;
  color: ${({ theme }) => theme.palette.colors.textBody || '#4B4E52'};
`;

export const StorybookWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  align-items: center;
  justify-content: center;
  padding: 15px;
`;

export const errorBorder = css`
  border: 1.5px solid ${({ theme }) => theme.palette.error || '#C94553'} !important;
`;

export const errorOutline = css`
  &:focus {
    outline: 1.5px solid ${({ theme }) => theme.palette.error || '#C94553'} !important;
  }
`;

const inputPlaceholderStyle = css`
  font-style: italic;
  font-size: ${({ theme }) => theme.typography.default} || '13px';
  color: ${({ theme }) => theme.palette.colors.placeholderColor || '#6d7278'};
`;

export const createErrorControlStyled = <T extends FunctionComponent>(
  component: T,
  // any is needed by styled-components
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => {
  return styled(component)<ValidationProps>`
    input,
    textarea {
      ${({ error }) => error && errorBorder};
      ${({ error }) => (error ? errorOutline : fieldOutline)};
      ::placeholder {
        ${inputPlaceholderStyle}
      }
      border: 1px solid ${({ theme }) => theme?.palette?.colors?.inputBorder || '#8696a7'};
    }
  `;
};
